var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenchmarking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-chart-histogram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3v18h18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16v5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13v8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16v5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11c6 0 5 -5 9 -5s3 5 9 5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarking);
export default __webpack_public_path__ + "static/media/benchmarking.77924ebb71c2bd9c703ab18bf4add95a.svg";
export { ForwardRef as ReactComponent };